export default () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.52872 6.2405L12.8376 1.32163L14.5846 1.31848L20.9876 6.23675L21.5073 7.3058V12.9255L20.9918 13.9908L14.5795 18.9153L12.8333 18.9062L6.53326 13.9934L6.02139 12.9314L6.02139 7.29881L6.52872 6.2405Z"
        stroke="white"
        strokeWidth="0.703906"
      />
      <rect
        x="5.66943"
        y="8.00537"
        width="0.703906"
        height="4.22343"
        fill="#2839D9"
      />
      <path
        d="M15.069 10.3661C15.2064 10.2286 15.2064 10.0058 15.069 9.86832L12.8292 7.62851C12.6917 7.49106 12.4689 7.49106 12.3314 7.62851C12.194 7.76595 12.194 7.9888 12.3314 8.12624L14.3224 10.1172L12.3314 12.1081C12.194 12.2456 12.194 12.4684 12.3314 12.6059C12.4689 12.7433 12.6917 12.7433 12.8292 12.6059L15.069 10.3661ZM0.0380859 10.4691L14.8201 10.4691L14.8201 9.76524L0.038086 9.76523L0.0380859 10.4691Z"
        fill="white"
      />
    </svg>
  );
};
